export class EspecialidadTecnica
{
    tipo_especialidad : string;
    evento_estado : string;
    tiempo_estimado :number;
    hora_inicio :string;
    hora_fin :string;
    empresa_id :string
    empresa_centro_id :string
}